import React, { forwardRef, useEffect, useRef, useState } from "react";
import { APIProvider, Map, AdvancedMarker } from "@vis.gl/react-google-maps";
import "../styles/InputAddress.css";
import config from '../config'; 

const InputAddress = forwardRef(({ value, label, onChange, placeholder }, ref) => {
  const defaultCenter = { lat: value.lat, lng: value.lng };
  const inputRef = useRef(null);
  const [markerPosition, setMarkerPosition] = useState(defaultCenter);
  const [mapCenter, setMapCenter] = useState(defaultCenter);
  
  useEffect(() => {

    if (ref) {
      if (typeof ref === "function") {
        ref(inputRef.current);
      } else {
        ref.current = inputRef.current;
      }
    }
  }, [ref]);

  useEffect(() => {
    const initAutocomplete = () => {
      if (window.google?.maps?.places?.Autocomplete && inputRef.current) {
        const autocomplete = new window.google.maps.places.Autocomplete(inputRef.current, {
          types: ["geocode"]
        });

        autocomplete.addListener("place_changed", () => {
          const place = autocomplete.getPlace();

          if (place?.geometry && place?.address_components) {
            const lat = place.geometry.location.lat();
            const lng = place.geometry.location.lng();
            const address = place.formatted_address;

            let city = "";
            let country = "";
            let street = "";
            let streetNumber = "";
            let postalCode = "";

            place.address_components.forEach((component) => {
              if (component.types.includes("locality")) {
                city = component.long_name;
              }
              if (component.types.includes("country")) {
                country = component.long_name; 
              }
              if (component.types.includes("route")) {
                street = component.long_name; 
              }
              if (component.types.includes("street_number")) {
                streetNumber = component.long_name; 
              }
              if (component.types.includes("postal_code")) {
                postalCode = component.long_name; 
              }
            });

            inputRef.current.value = address;

            if (onChange) {
              onChange({ address, country, city, postalCode, street, streetNumber, lat, lng, url: place.url });
            }
            setMarkerPosition({ lat, lng });
            setMapCenter({ lat, lng });
          }
        });
      }
    };

    const intervalId = setInterval(() => {
      if (window.google?.maps?.places?.Autocomplete) {
        clearInterval(intervalId);
        initAutocomplete();
      }
    }, 200);

    return () => clearInterval(intervalId);
  }, [onChange]);

  const handleKeyDown = (event) => {
    if (onChange) {
      const empty = {
        address: "",
        lat: 0,
        lng: 0,
        city: "",
        postalCode: "",
        street: "",
        streetNumber:"",
        country: "",
        url: ""
      }
      onChange(empty);
    }
  };
 
  return (
    <div className="input-wrapper">
      <APIProvider apiKey={config.googleMap.apiKey} libraries={["places"]}>
        {label && <label className="input-label">{label}</label>} 
        <div className="input-address-map" tabIndex="-1">
          <Map
            mapId={config.googleMap.id}
            defaultZoom={15}
            center={mapCenter}
            defaultCenter={mapCenter}
            gestureHandling={"greedy"}
            disableDefaultUI={true}
            options={{
              zoomControl: true,
              draggable: false,
              clickableIcons: false,
              disableDoubleClickZoom: true,
              disableDefaultUI: true
            }}
            tabIndex="-1"
          >
            <AdvancedMarker position={markerPosition} />
          </Map>
        </div>
        <input
          ref={inputRef}
          type="text"
          placeholder={placeholder}
          className="input-address"
          defaultValue={value.address}
          onKeyDown={handleKeyDown}
        />
      </APIProvider>
    </div>
  );
});

export default InputAddress;